import {Heading} from "components";
import React, {Suspense} from "react";
import {useTranslation} from "react-i18next";
import Bitrix24Tab from "./tabs";

export default function  Bitrix24Tabs() {

    const {t} = useTranslation();

    const Bitrix24TabsGrid =[
        {
            tabsNumber: "01",
            title: t("bitrix24.content.cards.1.title"),
            description: t("bitrix24.content.cards.1.description"),
            icon: "/images/services_1.svg",
        },
        {
            tabsNumber: "02",
            title: t("bitrix24.content.cards.2.title"),
            description: t("bitrix24.content.cards.2.description"),
            icon: "/images/services_2.svg",
        },
        {
            tabsNumber: "03",
            title: t("bitrix24.content.cards.3.title"),
            description: t("bitrix24.content.cards.3.description"),
            icon: "/images/services_3.svg",
        },{
            tabsNumber: "04",
            title: t("bitrix24.content.cards.4.title"),
            description: t("bitrix24.content.cards.4.description"),
            icon: "/images/services_4.svg",
        },
        {
            tabsNumber: "05",
            title: t("bitrix24.content.cards.5.title"),
            description: t("bitrix24.content.cards.5.description"),
            icon: "/images/services_5.svg",
        },
        {
            tabsNumber: "06",
            title: t("bitrix24.content.cards.6.title"),
            description: t("bitrix24.content.cards.6.description"),
            icon: "/images/services_6.svg",
        },
    ];

    return (
        <>
            <section id="Services">
                <div className="flex flex-col items-center px-6 sm:px-[16px]">
                    <div className="container-xs flex flex-col items-start gap-10">
                        <Heading
                            size="desktop_heading_4"
                            as="h2"
                            className="font-medium text-[#191c2fe5] leading-[33.6px] gap-4 uppercase">
                            {t("bitrix24.content.title")}
                        </Heading>
                        <div className="grid lg:grid-cols-3 grid-cols-1 gap-5 sm:gap-4 self-stretch">
                            <Suspense fallback={<div>Loading </div>}>
                                {Bitrix24TabsGrid.map((d, index) => (
                                    <Bitrix24Tab {...d} key={"grid" + index}/>
                                ))}
                            </Suspense>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}